module.exports = __webpack_public_path__ + "img/no_quit.c2d79737.png";